/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-card-content[_ngcontent-%COMP%]{padding-top:20px}mat-paginator[_ngcontent-%COMP%]{padding-right:60px}"];
export { styles as styles };
